import React from 'react';
import PropTypes from 'prop-types';

export default function MeasureIcon(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fillRule="evenodd" clipRule="evenodd" d="M3.79883 7H1.79883V9V16V18H3.79883H19.7988H21.7988V16V9V7H19.7988H3.79883ZM3.79883 9H5.79883H17.7988H19.7988V11V14V16H17.7988V12H15.7988V16H12.7988V11H10.7988V16H7.79883V12H5.79883V16H3.79883V14V11V9Z" fill={props.color || 'black'} />
    </svg>
  );
}

MeasureIcon.propTypes = {
  color: PropTypes.string
};